import {Component, OnInit, ViewChild} from '@angular/core';
import {TableSelectionAbstract} from '../../../../shared/component/table/table-selection.abstract';
import {DxDataGridComponent} from 'devextreme-angular';
import {AppConfigService} from '../../../../../app-config.service';
import {GeneralService} from '../../../../service/general-service';
import {OrderService} from '../../../../service/order-service';
import {TranslateService} from '@ngx-translate/core';
import {NotificationService} from '../../../../service/notification.service';
import {ShareaService} from '../../../../service/sharea.service';
import {DateFormatPipe} from '../../../../shared/pipe/format-date.pipe';
import {Constant} from '../../../../shared/constants/constant.class';
import {Workbook} from 'exceljs';
import {saveAs} from 'file-saver-es';
import * as moment from 'moment';
import CustomStore from 'devextreme/data/custom_store';
import {LoadOptions} from 'devextreme/data';
import {lastValueFrom} from 'rxjs';

@Component({
  selector: 'app-sms-log',
  templateUrl: './sms-log.component.html',
  styleUrls: ['./sms-log.component.scss']
})
export class SmsLogComponent extends TableSelectionAbstract
  implements OnInit {
  // dataSource giờ là CustomStore để dx-data-grid tự gọi API mỗi khi đổi trang/số dòng
  // (server-side paging), thay vì tải hết dữ liệu (pageSize: 15000) về client như trước.
  dataSource: any;
  data: any;
  orderCode: any;
  loading: boolean;
  page: any;
  pageSizeOption: any;
  defaultPageSize: any;
  cachedPayload: any;

  uploadUrl = '';
  uploadHeader: any;
  baseImageurl = '';
  dateFormat = 'dd/MM/yyyy';
  order: any;
  orderTypeGroups = [];
  filter: any;
  currentFilter: any;
  partners = [];
  @ViewChild (DxDataGridComponent) dataGrid: DxDataGridComponent;
  constructor(
    private configService: AppConfigService,
    private generalService: GeneralService,
    private orderService: OrderService,
    public translate: TranslateService,
    private notificationService: NotificationService,
    private shareService: ShareaService,
    private dateFormatPipe: DateFormatPipe,
  ) {
    super('id');
    this.uploadHeader = {
      Authorization: 'Bearer ' + localStorage.getItem(Constant.TOKEN),
    };
    this.uploadUrl = `${this.configService.getConfig().api.baseUrl}/file/upload`;
    this.baseImageurl = this.configService.getConfig().api.baseUrl + '/Uploads/';
    this.filter = {
      sid: null,
      phoneNo: null,
      fromDate: new Date(),
      toDate: new Date(),
    };
    this.getOrderGroup();
    this.getPartners();
  }
  getPartners() {
    this.generalService.getListPartner().subscribe((res) => {
      if (res !== null) {
        this.partners = res;
      }
    });
  }

  ngOnInit(): void {
    this.orderCode = '';
    this.pageSizeOption = this.configService.getConfig().pageSize;
    this.page = this.configService.getConfig().page;
    this.defaultPageSize = this.configService.getConfig().defaultPage;
    this.initTableHeight(1200);
    this.loadGrid();
  }

  getRowIndex = (index, pageIndex, pageSize) => index + 1 + pageSize * (pageIndex - 1);
  getOrderGroup(){
    this.generalService.listOrderGroup().subscribe((res) => {
      if (res !== null){
        this.orderTypeGroups = res;
      }
    }, error => {
    });
  }

  // Khởi tạo CustomStore: mỗi lần dx-data-grid cần dữ liệu (mở trang, đổi trang, đổi số
  // dòng/trang) nó sẽ tự gọi load() bên dưới, tính page/pageSize theo skip/take rồi gọi
  // API SmsLogFilter đúng payload BE yêu cầu (page, pageSize, fromDate, toDate, sid, phoneNo).
  // filter được giữ theo tham chiếu (không gán lại) nên khi người dùng bấm "Tìm kiếm" chỉ
  // cần đổi trang, không cần tạo lại CustomStore.
  loadGrid() {
    const orderService = this.orderService;
    const filter = this.filter;
    const thisCom = this;
    const defaultPageSize = this.defaultPageSize || 20;

    this.dataSource = new CustomStore({
      key: 'id',
      load: async (loadOptions: LoadOptions) => {
        try {
          const skip = loadOptions.skip ?? 0;
          const take = loadOptions.take ?? defaultPageSize;
          const page = Math.floor(skip / take) + 1;

          const payload = {
            page,
            pageSize: take,
            fromDate: filter.fromDate,
            toDate: filter.toDate,
            sid: filter.sid,
            phoneNo: filter.phoneNo,
          };
          thisCom.cachedPayload = payload;

          const res = await lastValueFrom(orderService.getSmsLogFilter(payload));
          const items = res?.data || [];

          return {
            data: items,
            totalCount: res?.total || 0
          };
        } catch (err) {
          console.log(err);
          return {data: [], totalCount: 0};
        }
      }
    });
  }

  // Bấm "Tìm kiếm": đưa grid về trang 1 để load lại theo filter mới nhất.
  // Lưu ý: nếu grid đang SẴN ở trang 1 (pageIndex = 0) thì gọi pageIndex(0) là no-op,
  // DevExtreme sẽ không bắn request nào cả (không có event trên Network tab) -> phải
  // check trước, nếu đã ở trang 0 rồi thì gọi refresh() để ép load lại.
  doSearch() {
    if (!this.dataGrid) {
      this.loadGrid();
      return;
    }
    const grid = this.dataGrid.instance;
    if (grid.pageIndex() === 0) {
      grid.refresh();
    } else {
      grid.pageIndex(0);
    }
  }

  clearSearch() {
    this.filter.sid = null;
    this.filter.phoneNo = null;
    this.filter.fromDate = new Date();
    this.filter.toDate = new Date();
    this.doSearch();
  }

  toAge(yob: any){
    return new Date().getFullYear() - +yob;
  }
  get() {
    this.translate.use(this.translate.currentLang).subscribe((data) => {
      this.data = data;
    });
  }

  // Xuất Excel: vì bảng giờ phân trang server (chỉ giữ 1 trang dữ liệu trong grid),
  // không thể xuất trực tiếp từ dxDataGrid như trước nữa. Gọi lại API với cùng điều
  // kiện lọc hiện tại (SID, SĐT, khoảng ngày) nhưng lấy pageSize lớn để có đủ toàn bộ
  // dữ liệu khớp filter rồi tự dựng file Excel.
  exportData() {
    const payload = {
      page: 1,
      pageSize: 20000,
      fromDate: this.filter.fromDate,
      toDate: this.filter.toDate,
      sid: this.filter.sid,
      phoneNo: this.filter.phoneNo,
    };
    this.loading = true;
    this.orderService.getSmsLogFilter(payload).subscribe((res) => {
      this.loading = false;
      const list = res?.data || [];
      this.buildExcel(list);
    }, () => {
      this.loading = false;
      this.notificationService.showNotification(Constant.ERROR, Constant.MESSAGE_SERVICE_ERROR);
    });
  }

  buildExcel(list: any[]) {
    const workbook = new Workbook();
    const worksheet = workbook.addWorksheet('SmsLog');
    worksheet.columns = [
      {header: 'Ngày gửi', key: 'dateSend', width: 20},
      {header: 'Nội dung', key: 'messageSend', width: 60},
      {header: 'SID', key: 'orderCode', width: 15},
      {header: 'SĐT', key: 'phoneNo', width: 15},
      {header: 'Người gửi', key: 'userSend', width: 15},
    ];
    list.forEach((item) => {
      worksheet.addRow({
        dateSend: item.dateSend ? this.dateFormatPipe.transformFull(item.dateSend, Constant.DATE_FMT_HOUR) : '',
        messageSend: item.messageSend,
        orderCode: item.orderCode,
        phoneNo: item.phoneNo,
        userSend: item.userSend,
      });
    });

    const from = this.dateFormatPipe.transformFull(this.filter.fromDate, Constant.DATE_FMT_STR);
    const to = this.dateFormatPipe.transformFull(this.filter.toDate, Constant.DATE_FMT_STR);
    const dateStr = from === to ? from : (from + '_' + to);
    const fileName = `SMS_log_${dateStr}`;
    workbook.xlsx.writeBuffer().then((buffer) => {
      saveAs(new Blob([buffer], {type: 'application/octet-stream'}), fileName + '.xlsx');
    });
  }

  exportPDF() {
    const partnerId = this.filter.partnerIds[0];
    const fromDate = moment(this.filter.fromDate).format('DD/MM/YYYY');
    const toDate = moment(this.filter.toDate).format('DD/MM/YYYY');
    const mainUrl = this.configService.getConfig().api.reportUrl + '/BridgeXLSDownload.aspx';
    const url = mainUrl + `?PartnerId=${partnerId}&report=PartnerRevenue&FromDate=${fromDate}&ToDate=${toDate}`;
    console.log(url);
    window.open(url, '_blank');
  }
}
